var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 61,
    viewBox: "0 0 1920 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_1484)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2199_1484)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2199_1484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19.4701V60.8612L1917.01 19.471V0.78125L2 19.4701Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.160156 60.8605H1919.84V19.2256L0.160156 60.8605Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_1484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 60.08,
    fill: "white",
    transform: "translate(0 0.780273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2199_1484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 60.08,
    fill: "white",
    transform: "translate(0 0.780273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2199_1484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1919.68,
    height: 60.08,
    fill: "white",
    transform: "translate(0.160156 0.780273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider1);
export default __webpack_public_path__ + "static/media/divider1.5670b796e704601e82a55281d5b29a13.svg";
export { ForwardRef as ReactComponent };